import React, { Component } from "react";
import * as Containers from "./components/containers";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import "./index.css";
import buildLink from "./functions/buildlink";

import { HomePage } from "./layout/index";
import { SinglePage } from "./layout/single";
import { CompromisosPage } from "./layout/compromisospage";

class App extends Component {
  render() {
    return (
      <Router>
        <Switch>
          <Containers.Wrapper>
            <Route path={buildLink()} component={HomePage} exact />
            <Route
              path={buildLink("compromisos-epn")}
              component={CompromisosPage}
              exact
            />
            <Route
              path={buildLink("entrada/:slug")}
              component={SinglePage}
              exact
            />
          </Containers.Wrapper>
        </Switch>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js